<template>
  <InputComponent
    @input="onChange"
    @keydown="onKeyDown"
    @blur="onBlur"
    :value="inputValue"
    type="text"
    v-bind="$props"
    id="input-tag"
  >
    <template v-if="inputTags" v-slot:leftIcons>
      <Tag
        v-for="(tag, index) in inputTags"
        :key="index"
        :class="tagClass(index)"
        :text="tag"
      >
        <template v-slot:rightIcons>
          <Icon
            name="remove"
            :handleClick="() => updateTagArray(tag)"
            size="16"
            class="icon"
          />
        </template>
      </Tag>
    </template>
  </InputComponent>
</template>

<script>
import Tag from '../Tag/Tag.vue';
import Icon from '../Icon/Icon.vue';
import InputComponent from '../Input/Input.vue';

export default {
  components: { Tag, InputComponent, Icon },
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    addOnBlur: {
      type: Boolean,
      default: true,
    },
    errorMessage: {
      type: String,
    },
  },
  data() {
    return {
      inputValue: this.value || '',
      inputTags: this.tags || [],
    };
  },
  methods: {
    onBlur() {
      if (this.addOnBlur) {
        this.onAddTag();
      }
    },
    onKeyDown(e) {
      const isAddKey = [',', ';', 'Enter'].some((key) => e.key === key);
      if (isAddKey) {
        e.preventDefault();
        this.onAddTag();
      }
    },
    onAddTag() {
      if (!this.inputValue) {
        return;
      }
      if (this.hasTagInArray(this.inputValue)) {
        this.$emit('errorMessage', 'Tag já cadastrada');
        return;
      }
      this.updateTagArray(this.inputValue);
      this.inputValue = '';
    },
    hasTagInArray(tag) {
      return this.tags.some((activeTag) => activeTag === tag);
    },
    updateTagArray(tag) {
      this.inputTags = this.getUpdatedTagArray(tag);
    },
    getUpdatedTagArray(tag) {
      if (!tag) {
        return;
      }
      if (this.hasTagInArray(tag)) {
        return this.tags.filter((activeTag) => activeTag !== tag);
      }
      return [...this.tags, tag];
    },
    onChange(value) {
      this.inputValue = value;
      this.$emit('errorMessage', '');
    },
    tagClass(index) {
      return {
        tag: true,
        'last-tag': index + 1 === this.inputTags.length,
      };
    },
  },
  watch: {
    inputTags() {
      this.$emit('input', this.inputTags);
    },
  },
};
</script>

<style lang="scss" scoped>
.tag {
  margin-top: calc(var(--track-spacing-sm) - 1px);
  margin-bottom: calc(var(--track-spacing-sm) - 1px);
  margin-right: var(--track-spacing-sm);
}

.last-tag {
  margin-right: 0;
}
svg {
  &.icon {
    cursor: pointer;
    fill: var(--track-color-bluegray-60);
  }
}
</style>
